import { getDropdownLookupFieldId } from './datasourceMapper';

const isNotFoundError = error => error?.status === 404 || error?.response?.status === 404;

/**
 * Ids of the fields that can no longer be shown on the records page because what they point at is gone:
 *  - a lookup-backed dropdown whose datasource/source field returned no choices entry,
 *  - a custom-object lookup whose target entity answered 404.
 * `choicesByFieldId` is the native-dropdown-choices result (null when it could not be loaded - then dropdowns are
 * left alone), `deletedRelatedEntityIds` the related entity ids that answered 404.
 */
export const getBrokenFieldIds = (fields, { choicesByFieldId = null, deletedRelatedEntityIds = new Set() } = {}) => {
  const brokenIds = new Set();
  (fields ?? []).forEach(field => {
    const lookupFieldId = getDropdownLookupFieldId(field);
    if (lookupFieldId != null) {
      if (choicesByFieldId && !choicesByFieldId.has(String(lookupFieldId))) brokenIds.add(field.id);
      return;
    }
    if (field.type === 'RELATIONSHIP' && deletedRelatedEntityIds.has(field.related_entity_id)) {
      brokenIds.add(field.id);
    }
  });
  return brokenIds;
};

export { isNotFoundError };
